<template>
  <div id="app">
    <NavBarAppComponent></NavBarAppComponent>
    <div class='main-content'>
      <transition
        @enter="enterArtisan"
        @leave="leaveArtisan"
        :css="false"
        >
        <div :key="this.$route.name" class="main-container">
          <router-view></router-view>
          <FooterAppComponent v-if="this.$route.name === 'HomePage'"></FooterAppComponent>
        </div>
      </transition>
    </div>
  </div>

</template>

<script>
import { gsap } from 'gsap'

import NavBarAppComponent from '@/components/NavBarAppComponent.vue'
import FooterAppComponent from '@/components/FooterAppComponent.vue'

export default {
  name: 'app',
  components: {
    NavBarAppComponent,
    FooterAppComponent
  },

  data () {
    return {
      direction: true
    }
  },

  watch: {
    '$route' (route, oldRoute) {
      const index = route.meta.sidebarIndex
      const oldIndex = oldRoute.meta.sidebarIndex
      this.direction = index < oldIndex
    }
  },

  computed: {
    isHomePage () {
      return this.$route.name === 'HomePage'
    }
  },

  methods: {

    enterArtisan (el, done) {
      const tl = gsap.timeline({ onComplete: done })
      const elem = el.querySelectorAll('.categories-detail, :scope > div, .faq-details > div')

      tl
        .from(
          el,
          { duration: 0.5, x: this.direction ? '-100%' : '100%', clearProps: 'all', ease: 'power4.inOut' },
          'a'
        )
        .from(
          elem,
          { duration: 0.75, x: this.direction ? '-100%' : '100%', autoAlpha: 0, clearProps: 'all', ease: 'power4.inOut', stagger: 0.025 },
          'a'
        )
    },
    leaveArtisan (el, done) {
      const tl = gsap.timeline({ onComplete: done })

      tl
        .to(
          el,
          { duration: 0.5, x: this.direction ? '100%' : '-100%', clearProps: 'all', ease: 'power4.inOut' },
          'a'
        )
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,700|Raleway:300,400,500,600,700');

::-webkit-scrollbar {
  display: none;
}

html, body, *{
  margin: 0;
  padding: 0;
  font-family: 'Montserrat';
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}

html, body {
  background: #3a3635;
  overflow-x: hidden;
  max-width: 100vw;
}

#app {
  display: flex;
  flex-direction: column;

  min-height: 100vh;
  width: 100%;

  .main-content {
    display: flex;
    flex-direction: row;

    flex-grow: 1;
    background-color: #f1f1f1;
    overflow: hidden;
  }

  .main-container {
    position: absolute;
    overflow: hidden;

    background: #f1f1f1;

    display: flex;
    flex-direction: column;

    width: 100vw;
  }
}
</style>
